import { ApolloFetchPolicy } from "shared/types/ApolloFetchPolicy"

import { useAttachmentEntitiesQuery as useAttachmentEntitiesQueryGenerated } from "../graphql/attachment-entities.queries.generated"

interface Args {
  id: string
  skip?: boolean
  fetchPolicy?: ApolloFetchPolicy
}

export function useAttachmentEntitiesQuery({ id, skip, fetchPolicy }: Args) {
  return useAttachmentEntitiesQueryGenerated({
    variables: { id },
    skip,
    fetchPolicy
  })
}
